import { Action } from "csi/def/Action";
import SaveDialogStore from "designSystem/components/dialog/store/SaveDialogStore";
import { observer } from "mobx-react-lite";
import React from "react";
import { FunctionComponent } from "react";
import { Button, FlexRowCenter } from "designSystem/index";
import html from "csi/html";
import { ViewWidget } from "csi/view/Widget";
import csiAction from "csi/action";

interface GoToDialogButtonsProps {
	/** pass in legacy dojo actions */
	actions: Action[];
	/** disable save button prop */
	disableSave: boolean;
	/** dojo view to invoke an action */
	dojoView: ViewWidget;
	/** process save button */
	onSaveDialog: () => Promise<void>;
}

export const GoToDialogButtons: FunctionComponent<GoToDialogButtonsProps> = observer(({ actions, disableSave, dojoView, onSaveDialog }) => {
	return (
		<FlexRowCenter gap={2}>
			{actions.map((action) => {
				const { m_class, m_id } = action;
				const isPrimaryButton = m_class.includes(html.CSS_ENABLE_ON_CHANGE);
				async function callInvoke(bSave: boolean): Promise<void> {
					if (bSave) {
						await onSaveDialog();
					} else {
						csiAction.invoke(dojoView, null, action);
					}
				}
				return (
					<Button
						className={m_class}
						design={isPrimaryButton ? "primary" : undefined}
						disabled={disableSave && isPrimaryButton}
						key={m_id}
						onClick={() => callInvoke(isPrimaryButton)}
						res={m_id}
					/>
				);
			})}
		</FlexRowCenter>
	);
});
